import { IStaticConfig } from './typings';

export const defaultConfig: IStaticConfig = {
  changeSearch : {
    timeDropdown12Hr   : false,
    defaultPickupTime  : '1030AM',
    defaultDropoffTime : '1030AM'
  },
  environment : {
    test : {
      rcpRedirect : {
        isRedirectStandalone : false,
        isRedirectPackage    : false
      }
    },
    prod : {
      rcpRedirect : {
        isRedirectStandalone : false,
        isRedirectPackage    : false
      }
    }
  },
  isEMEA                  : false,
  isAnimatedLoaderEnabled : false
};
